import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateProfessionalNumber from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError, fetchRealtimeValidations } from '../../data/actions';

/**
 * Name field wrapper. It accepts following handlers
 * - handleChange for setting value change and
 * - handleErrorChange for setting error
 *
 * It is responsible for
 * - Making backend call for generating username suggestions
 * - Performing name field validations
 * - Clearing error on focus
 * - Setting value on change
 */
const ProfessionalNumberField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const validationApiRateLimited = useSelector(state => state.register.validationApiRateLimited);

  const {
    handleChange,
    handleErrorChange,
    shouldFetchUsernameSuggestions,
  } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateProfessionalNumber(value, formatMessage);
    if (fieldError) {
      handleErrorChange('professional_number', fieldError);
    } else if (shouldFetchUsernameSuggestions && !validationApiRateLimited) {
      dispatch(fetchRealtimeValidations({ name: value }));
    }
  };

  const handleOnFocus = () => {
    handleErrorChange('professional_number', '');
    dispatch(clearRegistrationBackendError('professional_number'));
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    handleChange(e);

    const fieldError = validateProfessionalNumber(value, formatMessage);
    handleErrorChange('professional_number', fieldError || '');
  };

  return (
    <FormGroup
      {...props}
      handleChange={handleOnChange}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

ProfessionalNumberField.defaultProps = {
  errorMessage: '',
  shouldFetchUsernameSuggestions: false,
};

ProfessionalNumberField.propTypes = {
  errorMessage: PropTypes.string,
  shouldFetchUsernameSuggestions: PropTypes.bool,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default ProfessionalNumberField;
